import { render, staticRenderFns } from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=template&id=16c13dce&scoped=true"
import script from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c13dce",
  null
  
)

export default component.exports